export default "__VITE_ASSET__lTh1cmph__"